// extracted by mini-css-extract-plugin
export var licenses = "licenses-module--licenses--5175e";
export var licenses__container = "licenses-module--licenses__container--79049";